import { get, post } from "services/network/endpoint"
import { dispatchHandler } from "services/utils/action"
import * as ActionTypes from "services/state/action-types"

import { BFF } from "services/network/routes"

export function leadShareEnergy(data, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      client: BFF,
      data
    }
    const request = post("leadShareEnergy", config)

    return dispatch({
      type: ActionTypes.LEAD_SHARED_ENERGY,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getEnergyDistributor(callback, callbackFail) {
  return (dispatch) => {
    const config = {
      client: BFF
    }
    const request = get("getEnergyDistributor", config)

    return dispatch({
      type: ActionTypes.ENERGY_DISTRIBUTOR,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}



// WEBPACK FOOTER //
// ./src/services/state/gedisa/actions.js